import { all, call, fork } from 'redux-saga/effects';
import { map } from 'lodash/fp';
import * as Sentry from '@sentry/browser';

import { sagas as auth } from '../auth';
import { sagas as connection } from '../connection';
import { sagas as newsletter } from '../newsletter';
import { sagas as newsletters } from '../newsletters';
import { sagas as targets } from '../targets';
import { sagas as token } from '../token';
import { sagas as errors } from '../../errors';

const sagas = {
  ...auth,
  ...connection,
  ...newsletter,
  ...newsletters,
  ...targets,
  ...token,
  ...errors,
};

export default function* rootSaga() {
  try {
    yield all(map((saga) => fork(saga), sagas));
  } catch (error) {
    yield call([Sentry, 'captureException'], error);
  }
}
